import { createContext, ReactNode, useContext, useMemo, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "../hooks/useLocalStorage";
import { clearStorage, removeStoreItem, setItemInStorage, setObjectInStore, storageKeys } from "../storage/Storage";
import { getUserDetailService, socialLoginService } from "../services/userService";
import { toast } from "react-toastify";
import { STATUS_200, STATUS_300 } from "../data/constants";
import { setUserDetails, setUserDetailsError, setUserDetailsLoading } from "../redux/slices/login";
import { errorMessage } from "../lib/helper";
export const AuthContext = createContext({});

interface Props {
  children?: ReactNode
  // any props that come into the component
}

type Auth = {
  user: object,
  login: any,
  logout: any,
  socialLogin: any,
  setUser: () => {},
};

export const AuthProvider: React.FC<{}> = ({ children }: Props) => {
  const [user, setUser] = useLocalStorage("user", null);
  const [isInit, setIsInit] = useState(true);
  const navigate = useNavigate();

  // call this function when you want to authenticate the user
  const login = async (data: any) => {
    setUser(data);
    navigate("/");
  };
  // call this function to sign out logged in user
  const logout = () => {
    setUser(null);
    clearStorage()
    navigate("/", { replace: true });
  };

  const updateUserProfile = async () => {
    try {
      const response = await getUserDetailService();
      if (response?.data) {
        const updatedUser = response?.data;
        setUser(updatedUser);
        setObjectInStore(storageKeys.authUser, updatedUser);
        // removeStoreItem(storageKeys.token);
      }
    } catch (error) { }
  };

  const socialLogin = async (params: any) => {
    try {
      const resp = await socialLoginService(params);
      if (resp?.status >= STATUS_200 && resp?.status < STATUS_300) {
        setItemInStorage('token', resp?.data?.token);
        setItemInStorage('ref_token', resp?.data?.refreshAuth);
        const response = await getUserDetailService();
        if (response?.data) {
          const updatedUser = response?.data;
          login(updatedUser)
          setUser(updatedUser);
          setObjectInStore(storageKeys.authUser, updatedUser);
          toast.success(response.data.message, {
            autoClose: 2500,
          });
          return true
        } else {
          toast.success(response?.data?.data);
        }
      } else {
        throw resp
      }
    }
    catch (e) {
      // toast.error("Account is inactive.");
      toast.error(errorMessage(e), {
        autoClose: 2500,
      });
      return false
    }
  }

  const value: Auth = useMemo(
    () => ({
      user,
      login,
      logout,
      setUser: setUser,
      socialLogin: socialLogin,
      updateUserProfile: updateUserProfile,
    }),
    [user]
  );
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};